import React from "react";
import InlineEdit from '../../Components/InlineEdit';
import { Calendar, MapPin, FileText, Check, X, Tent, Users, Caravan } from 'lucide-react'; // Added icons
import { DatePicker } from '@mui/x-date-pickers';
import moment from 'moment';

class ReservationData extends React.Component {

    render() {
        const reservation = this.props.reservation;

        const statusColors = {
            ordered: 'bg-blue-100 text-blue-700 border-blue-200',
            onwater: 'bg-green-100 text-green-700 border-green-200', // active
            finished: 'bg-gray-100 text-gray-700 border-gray-200',
            canceled: 'bg-red-100 text-red-700 border-red-200',
        };

        const statusOptions = [
            { value: 'ordered', label: 'Objednaná' },
            { value: 'onwater', label: 'Na vode' },
            { value: 'canceled', label: 'Zrušená' },
            { value: 'finished', label: 'Ukončená' },
        ];

        return (
            <div className="bg-white shadow-sm border border-gray-100 p-5 md:p-6 hover:shadow transition-shadow">
                <div className="flex items-center justify-between mb-6">
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 bg-taborisko-orange/10 rounded-xl flex items-center justify-center">
                            <Tent className="w-5 h-5 text-taborisko-orange" />
                        </div>
                        <h3 className="text-lg font-bold text-taborisko-pine uppercase tracking-wide">Rezervácia (Kemping)</h3>
                    </div>
                </div>

                <div className="space-y-4">
                    {/* Status - Always Editable */}
                    <div className="flex items-start gap-3">
                        <div className="flex-1">
                            <InlineEdit
                                label="Stav"
                                alwaysEditing={true}
                                renderInput={({ save }) => (
                                    <select
                                        value={reservation.status}
                                        onChange={(e) => this.props.onUpdate({ status: e.target.value })}
                                        className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all font-medium ${statusColors[reservation.status] || 'border-gray-300'}`}
                                    >
                                        {statusOptions.map(opt => (
                                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                                        ))}
                                    </select>
                                )}
                            />
                        </div>
                    </div>

                    {/* Language - Always Editable */}
                    <div className="flex items-start gap-3">
                        <div className="flex-1">
                            <InlineEdit
                                label="Jazyk"
                                alwaysEditing={true}
                                renderInput={({ save }) => (
                                    <select
                                        value={reservation.language || 'sk'}
                                        onChange={(e) => this.props.onUpdate({ language: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all font-medium"
                                    >
                                        <option value="sk">Slovenský</option>
                                        <option value="en">Anglický</option>
                                    </select>
                                )}
                            />
                        </div>
                    </div>

                    {/* Dates - Grouped Inline Edit */}
                    <div className="group">
                        <InlineEdit
                            label="Termín"
                            hideLabel={true}
                            value={
                                <>
                                    <div className="flex items-start gap-3 mb-2">
                                        <div className="w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-secondary-50 transition-colors">
                                            <Calendar className="w-4 h-4 text-gray-600 group-hover:text-secondary-600" />
                                        </div>
                                        <div className="flex-1">
                                            <p className="text-xs text-gray-500 uppercase tracking-wide mb-0.5">Dĺžka pobytu</p>
                                            <p className="text-base font-medium text-gray-900">{this.props.reservationLength} {this.props.reservationLength === 1 ? 'deň' : 'dni'}</p>
                                        </div>
                                    </div>
                                    <div className="flex items-start gap-3">
                                        <div className="w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-secondary-50 transition-colors">
                                            <Calendar className="w-4 h-4 text-gray-600 group-hover:text-secondary-600" />
                                        </div>
                                        <div className="flex-1">
                                            <p className="text-xs text-gray-500 uppercase tracking-wide mb-0.5">Termín</p>
                                            <p className="text-base font-medium text-gray-900">{this.props.dateText}</p>
                                        </div>
                                    </div>
                                </>
                            }
                            onSave={(newValues) => this.props.onUpdate(newValues)}
                            renderInput={({ save, cancel }) => (
                                <DateRangeEditor
                                    startDate={reservation.start_date}
                                    endDate={reservation.end_date}
                                    onSave={save}
                                    onCancel={cancel}
                                />
                            )}
                        />
                    </div>

                    {/* Type of Stay */}
                    <div className="group">
                        <InlineEdit
                            label="Typ"
                            hideLabel={true}
                            value={
                                <div className="flex items-start gap-3 group">
                                    <div className="w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-secondary-50 transition-colors">
                                        {reservation.type_of_stay === 'day' ?
                                            <Calendar className="w-4 h-4 text-gray-600 group-hover:text-secondary-600" /> :
                                            <Tent className="w-4 h-4 text-gray-600 group-hover:text-secondary-600" />
                                        }
                                    </div>
                                    <div className="flex-1">
                                        <p className="text-xs text-gray-500 uppercase tracking-wide mb-0.5">Typ pobytu</p>
                                        <p className="text-base font-medium text-gray-900">
                                            {reservation.type_of_stay === 'day' ? 'Deň' : 'Nocuje'}
                                        </p>
                                    </div>
                                </div>
                            }
                            onSave={(val) => this.props.onUpdate({ type_of_stay: val })}
                            renderInput={({ save, cancel }) => (
                                <TypeEditor value={reservation.type_of_stay} onSave={save} onCancel={cancel} />
                            )}
                        />
                    </div>

                    {/* Counts Grouped */}
                    <div className="group">
                        <InlineEdit
                            label="Počty"
                            hideLabel={true}
                            value={
                                <>
                                    <div className="flex items-start gap-3 mb-2">
                                        <div className="w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-secondary-50 transition-colors">
                                            <Tent className="w-4 h-4 text-gray-600 group-hover:text-secondary-600" />
                                        </div>
                                        <div className="flex-1">
                                            <p className="text-xs text-gray-500 uppercase tracking-wide mb-0.5">Stany</p>
                                            <p className="text-base font-medium text-gray-900">{reservation.tents_count || 0}</p>
                                        </div>
                                    </div>
                                    <div className="flex items-start gap-3 mb-2">
                                        <div className="w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-secondary-50 transition-colors">
                                            <Users className="w-4 h-4 text-gray-600 group-hover:text-secondary-600" />
                                        </div>
                                        <div className="flex-1">
                                            <p className="text-xs text-gray-500 uppercase tracking-wide mb-0.5">Osoby</p>
                                            <p className="text-base font-medium text-gray-900">
                                                {reservation.adults_count || 0} dospelí, {reservation.children_count || 0} deti
                                            </p>
                                        </div>
                                    </div>
                                    {reservation.cars_count > 0 && (
                                        <div className="flex items-start gap-3">
                                            <div className="w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-secondary-50 transition-colors">
                                                <Caravan className="w-4 h-4 text-gray-600 group-hover:text-secondary-600" />
                                            </div>
                                            <div className="flex-1">
                                                <p className="text-xs text-gray-500 uppercase tracking-wide mb-0.5">Autá</p>
                                                <p className="text-base font-medium text-gray-900">{reservation.cars_count}</p>
                                            </div>
                                        </div>
                                    )}
                                    {reservation.caravans_count > 0 && (
                                        <div className="flex items-start gap-3 mt-2">
                                            <div className="w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-secondary-50 transition-colors">
                                                <Caravan className="w-4 h-4 text-gray-600 group-hover:text-secondary-600" />
                                            </div>
                                            <div className="flex-1">
                                                <p className="text-xs text-gray-500 uppercase tracking-wide mb-0.5">Karavany</p>
                                                <p className="text-base font-medium text-gray-900">{reservation.caravans_count}</p>
                                            </div>
                                        </div>
                                    )}
                                </>
                            }
                            onSave={(val) => this.props.onUpdate(val)}
                            renderInput={({ save, cancel }) => (
                                <CountsEditor
                                    tents={reservation.tents_count}
                                    adults={reservation.adults_count}
                                    children={reservation.children_count}
                                    cars={reservation.cars_count}
                                    caravans={reservation.caravans_count}
                                    onSave={save}
                                    onCancel={cancel}
                                />
                            )}
                        />
                    </div>

                    {/* Note */}
                    <div>
                        <div className="h-px bg-gray-200 my-3"></div>
                        <InlineEdit
                            label="Poznámka"
                            hideLabel={true}
                            value={
                                <div className="flex items-start gap-3 group">
                                    <div className="w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-warning-50 transition-colors">
                                        <FileText className="w-4 h-4 text-gray-600 group-hover:text-warning-600" />
                                    </div>
                                    <div className="flex-1">
                                        <p className="text-xs text-gray-500 uppercase tracking-wide mb-1">Poznámka</p>
                                        {reservation.note ? (
                                            <p className="text-sm text-gray-700 bg-warning-50 rounded-lg p-3 border border-warning-100">
                                                {reservation.note}
                                            </p>
                                        ) : (
                                            <p className="text-sm text-gray-400 italic">Žiadna poznámka</p>
                                        )}
                                    </div>
                                </div>
                            }
                            onSave={(val) => this.props.onUpdate({ note: val })}
                            renderInput={({ save, cancel }) => (
                                <NoteEditor value={reservation.note} onSave={save} onCancel={cancel} />
                            )}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

// Helpers
const EditorActions = ({ onSave, onCancel }) => (
    <div className="flex justify-end gap-2 mt-2">
        <button onClick={onCancel} className="p-1 text-gray-500 hover:bg-gray-100 rounded">
            <X size={18} />
        </button>
        <button onClick={onSave} className="p-1 text-white bg-success-600 hover:bg-success-700 rounded shadow-sm">
            <Check size={18} />
        </button>
    </div>
);

const DateRangeEditor = ({ startDate, endDate, onSave, onCancel }) => {
    const [start, setStart] = React.useState(startDate);
    const [end, setEnd] = React.useState(endDate);

    const handleSave = () => {
        onSave({ start_date: start, end_date: end });
    };

    return (
        <div className="bg-white p-3 border border-primary-200 rounded-lg shadow-sm">
            <div className="space-y-3">
                <DatePicker
                    label="Od"
                    value={moment(start)}
                    onChange={(d) => setStart(d?.toDate())}
                    slotProps={{ textField: { size: 'small', fullWidth: true } }}
                />
                <DatePicker
                    label="Do"
                    value={moment(end)}
                    onChange={(d) => setEnd(d?.toDate())}
                    slotProps={{ textField: { size: 'small', fullWidth: true } }}
                />
            </div>
            <EditorActions onSave={handleSave} onCancel={onCancel} />
        </div>
    )
}

const TypeEditor = ({ value, onSave, onCancel }) => {
    const [val, setVal] = React.useState(value);
    return (
        <div className="bg-white p-3 border border-primary-200 rounded-lg shadow-sm">
            <select value={val} onChange={e => setVal(e.target.value)} className="w-full border rounded p-2">
                <option value="day">Deň</option>
                <option value="night">Nocuje</option>
            </select>
            <EditorActions onSave={() => onSave(val)} onCancel={onCancel} />
        </div>
    )
}

const CountsEditor = ({ tents, adults, children, cars, caravans, onSave, onCancel }) => {
    const [t, setT] = React.useState(tents || 0);
    const [a, setA] = React.useState(adults || 0);
    const [c, setC] = React.useState(children || 0);
    const [car, setCar] = React.useState(cars || 0);
    const [cv, setCv] = React.useState(caravans || 0);

    const handleSave = () => {
        onSave({
            tents_count: parseInt(t) || 0,
            adults_count: parseInt(a) || 0,
            children_count: parseInt(c) || 0,
            cars_count: parseInt(car) || 0,
            caravans_count: parseInt(cv) || 0
        });
    }

    return (
        <div className="bg-white p-3 border border-primary-200 rounded-lg shadow-sm">
            <div className="grid grid-cols-2 gap-3 mb-2">
                <div>
                    <span className="text-xs text-gray-500">Stany</span>
                    <input type="number" min="0" value={t} onChange={e => setT(e.target.value)} className="w-full border rounded p-1" />
                </div>
                <div>
                    <span className="text-xs text-gray-500">Autá</span>
                    <input type="number" min="0" value={car} onChange={e => setCar(e.target.value)} className="w-full border rounded p-1" />
                </div>
                <div>
                    <span className="text-xs text-gray-500">Dospelí</span>
                    <input type="number" min="0" value={a} onChange={e => setA(e.target.value)} className="w-full border rounded p-1" />
                </div>
                <div>
                    <span className="text-xs text-gray-500">Deti</span>
                    <input type="number" min="0" value={c} onChange={e => setC(e.target.value)} className="w-full border rounded p-1" />
                </div>
                <div className="col-span-2">
                    <span className="text-xs text-gray-500">Karavany</span>
                    <input type="number" min="0" value={cv} onChange={e => setCv(e.target.value)} className="w-full border rounded p-1" />
                </div>
            </div>
            <EditorActions onSave={handleSave} onCancel={onCancel} />
        </div>
    )
}

const NoteEditor = ({ value, onSave, onCancel }) => {
    const [val, setVal] = React.useState(value || '');
    return (
        <div className="bg-white p-3 border border-primary-200 rounded-lg shadow-sm">
            <textarea
                className="w-full border rounded p-2 min-h-[80px]"
                value={val}
                onChange={e => setVal(e.target.value)}
                placeholder="Poznámka..."
                onKeyDown={(e) => {
                    if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) {
                        onSave(val);
                    }
                }}
            />
            <div className="text-[10px] text-gray-400 mt-1 text-right">Ctrl+Enter na uloženie</div>
            <EditorActions onSave={() => onSave(val)} onCancel={onCancel} />
        </div>
    )
}

export default ReservationData;
